export interface FacetSettings {
  keepOrderType?: boolean;
}

export enum OrderMethod {
  DELIVERY = 'delivery',
  PICKUP = 'pickup',
  DELIVERY_OR_PICKUP = 'delivery_or_pickup',
  CATERING = 'catering',
}

export interface BreadCrumb {
  value: string;
  link_fragment: string;
}

export interface Sort {
  key: string;
  linkFragment: string;
}

export interface ExtraParams {
  facet?: any;
  facetCount?: any;
  pageNum?: number;
  distance?: number;
  delivery_time?: string;
  non_dietary_cuisine?: string;
  dietary_cuisine?: string;
  order_type?: string;
  brand_id_uncollapsed?: string;
}

export type FacetTuple = [string, string | number, any];
export type FacetHashMap = Record<string, boolean>;

export const DEFAULT_DELIVERY_TIME = 75;
export const DEFAULT_DISTANCE_UNIT = 'mi';
export const DEFAULT_TIME_UNIT = 'min';
export const DEFAULT_PAGE_SIZE = 20;

export const FACET_SET_UMAMI_V2 = 'umamiV2';
export const SORT_SET_ID_DEFAULT = 'umamiV2';

export interface SearchQueryBreadCrumb {
  value: string;
  link_fragment: string;
}
